import React from 'react';
import PropTypes from 'prop-types';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import BackToEbonsButton from './BackToEbonsButton';

// commande e-card annulée par le fournisseur temps réel
const ProviderUnavailableBloc = ({ i18n }) => (
    <React.Fragment>
        <p>{convertHtmlToReactDomWithParams(i18n.PROVIDER_UNAVAILABLE_TEXT_1)}</p>
        <p>{i18n.PROVIDER_UNAVAILABLE_TEXT_2}</p>
        <br />
        <BackToEbonsButton text={i18n.BUTTON_TEXT} />
    </React.Fragment>
);

ProviderUnavailableBloc.propTypes = {
    i18n: PropTypes.object.isRequired
};

export default ProviderUnavailableBloc;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ProviderUnavailableBloc.js